export default "__VITE_ASSET__CXWZ7Ka3__"